import { useContext } from "react";
import { SelectRowsContext } from "../context";

const useSelectRowsContext = () => {
  const context = useContext(SelectRowsContext);
  if (!context)
    throw new Error(
      "useSelectRowsContext must be used within SelectRowsContextProvider"
    );
  return context;
};

export default useSelectRowsContext;
